// TODO: Need refactoring

import Vue from 'vue';

import * as filters from './lib/filters';
import * as vendors from './lib/vendors';
import * as formattingAmounts from './lib/formattingAmounts';
import * as formattingData from './lib/formattingData';
import * as awsDisplayFilters from './lib/awsDisplay';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Object.keys(vendors).forEach(key => {
  Vue.filter(key, vendors[key]);
});

Object.keys(formattingAmounts).forEach(key => {
  Vue.filter(key, formattingAmounts[key]);
});

Object.keys(formattingData).forEach(key => {
  Vue.filter(key, formattingData[key]);
});

Object.keys(awsDisplayFilters).forEach(key => {
  Vue.filter(key, awsDisplayFilters[key]);
});
